import { FieldType } from "../../type-system/FieldType";
import {
  ShopifyDiscountCustomerBuysProductVariantIdKey,
  ShopifyDiscountCustomerBuysProductVariantKey,
  ShopifyDiscountCustomerBuysProductVariantToDiscountKey,
  ShopifyDiscountCustomerBuysProductVariantToProductVariantKey,
  ShopifyDiscountCustomerBuysProductVariantToShopKey,
  ShopifyDiscountKey,
  ShopifyProductVariantKey,
  ShopifyShopKey,
} from "./keys";
import { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyDiscountCustomerBuysProductVariantKey,
  "2023-07": {
    name: "Shopify Discount Customer Buys Product Variant",
    fields: [
      {
        name: "ID",
        key: ShopifyDiscountCustomerBuysProductVariantIdKey,
        fieldType: FieldType.ID,
      },
      {
        name: "Discount",
        fieldType: FieldType.BelongsTo,
        key: ShopifyDiscountCustomerBuysProductVariantToDiscountKey,
        configuration: {
          relatedModelKey: ShopifyDiscountKey,
        },
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "discountId",
            skipGraphQLSelection: true,
          },
        },
      },
      {
        name: "Product Variant",
        fieldType: FieldType.BelongsTo,
        key: ShopifyDiscountCustomerBuysProductVariantToProductVariantKey,
        configuration: {
          relatedModelKey: ShopifyProductVariantKey,
        },
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "productVariantId",
            skipGraphQLSelection: true,
          },
        },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyDiscountCustomerBuysProductVariantToShopKey,
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    // in somewhat of a gross an anti-pattern, because shopifyDiscount is already synced through
    // a complicated custom sync, we also sync this model as part of it
    // although note, that we also need to do this sync on discount webhooks since shopify doesn't
    // send the full discount object in the webhook; so the actual place where the syncing happens is
    // in ShopifyDiscountGraphQLHandler
    syncConfig: { type: "inherit" },
  },
};

export const ShopifyDiscountCustomerBuysProductVariant = ({
  apiVersion,
  frameworkVersionConstraint,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint?: string;
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint);
